import React from 'react';

const formatChangeValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
};

const hasChangeValue = (value) => (
  value !== null && value !== undefined && value !== ''
);

const PartnerActivityLog = ({ entries, emptyMessage = 'No activity recorded yet.' }) => {
  if (!entries.length) {
    return <p className="partner-activity-log-empty">{emptyMessage}</p>;
  }

  return (
    <ol className="partner-activity-log">
      {entries.map((entry, index) => {
        const isLast = index === entries.length - 1;
        const showPaeNote = Boolean(entry.note) && (
          entry.kind === 'psm_note'
          || entry.kind === 'submission'
          || entry.kind === 'status_with_note'
          || entry.kind === 'approved_with_note'
        );
        const sublineParts = [
          entry.author ? `By ${entry.author}` : '',
          entry.summary || '',
        ].filter(Boolean);

        return (
          <li
            key={entry.id}
            className={`partner-activity-log-item partner-activity-log-item--${entry.kind}`}
          >
            <div className="partner-activity-log-rail" aria-hidden="true">
              <span className="partner-activity-log-dot" />
              {!isLast ? <span className="partner-activity-log-line" /> : null}
            </div>
            <article className="partner-activity-log-card">
              <header className="partner-activity-log-head">
                <div className="partner-activity-log-head-main">
                  <span className="partner-activity-log-badge">{entry.badge}</span>
                  <h3 className="partner-activity-log-title">{entry.title}</h3>
                </div>
                {entry.dateTime ? (
                  <time className="partner-activity-log-time" dateTime={entry.timestamp || undefined}>
                    {entry.dateTime}
                  </time>
                ) : null}
              </header>
              {sublineParts.length > 0 ? (
                <p className="partner-activity-log-subline">{sublineParts.join(' · ')}</p>
              ) : null}
              {entry.changes?.length > 0 ? (
                <ul className="partner-activity-log-changes">
                  {entry.changes.map((change) => {
                    const showFromTo = hasChangeValue(change.from);
                    return (
                    <li
                      key={`${entry.id}-${change.field}`}
                      className={`partner-activity-log-change${showFromTo ? '' : ' partner-activity-log-change--compact'}`}
                    >
                      <span className="partner-activity-log-change-label">{change.label}</span>
                      {showFromTo ? (
                      <span className="partner-activity-log-change-values">
                        <span className="partner-activity-log-change-from">
                          {formatChangeValue(change.from)}
                        </span>
                        <span className="partner-activity-log-change-arrow" aria-hidden="true">→</span>
                        <span className="partner-activity-log-change-to">
                          {formatChangeValue(change.to)}
                        </span>
                      </span>
                      ) : (
                        <span className="partner-activity-log-change-single">
                          {formatChangeValue(change.to)}
                        </span>
                      )}
                    </li>
                    );
                  })}
                </ul>
              ) : null}
              {showPaeNote ? (
                <div className="partner-activity-log-note">
                  <span className="partner-activity-log-note-label">
                    {entry.noteLabel || 'PAE note'}
                  </span>
                  <p>{entry.note}</p>
                </div>
              ) : null}
            </article>
          </li>
        );
      })}
    </ol>
  );
};

export default PartnerActivityLog;
